(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.announcement-bar[data-dismissible]').forEach(function (bar) {
    var key = 'ab-dismissed-' + bar.getAttribute('data-ab-id');
    try {
      if (localStorage.getItem(key) === '1') {
        bar.style.display = 'none';
        return;
      }
    } catch (e) {}
    var close = bar.querySelector('.announcement-bar__close');
    if (close) {
      close.addEventListener('click', function () {
        bar.style.display = 'none';
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
